
import _ from "lodash";
import React from "react";
import { DatagridProps, useTranslate } from "react-admin";
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, TooltipProps, Legend } from 'recharts';
import { scaleTime } from "d3-scale"
import { timeDay } from "d3-time"
import { timeFormat } from "d3-time-format"
import { Card, CardContent, makeStyles, Typography, useTheme } from "@material-ui/core";
import { formatMoney } from "../utils/formatters";

const parseGraphData = (repaymentRate: number, transactions: any) => {
    return transactions.map((t: any) => {
        return {
            repayment: t.value || 0,
            gross_sales: t.collections.aggregate.sum.gross_sales || 0,
            transfer: t.transfer_to_merchant && t.transfer_to_merchant >= 0 ? t.transfer_to_merchant : 0,
            date: new Date(t.timestamp).getTime()
        }
    })

}
const useStyles = makeStyles({
    tooltip: {
        Display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
    },
    tooltipLabel: {
        fontWeight: 'bold'
    }
})


interface StackedBarchartProps extends DatagridProps {
    repaymentRate: number;
}

const StackedBarchart = (props: StackedBarchartProps) => {
    const theme = useTheme();
    const translate = useTranslate()

    const { data: transactions, repaymentRate } = props
    // console.log(transactions)
    if (_.isEmpty(transactions)) return null

    const data = parseGraphData(repaymentRate, Object.values(transactions as any))
    // console.log(data)

    let firstDay = new Date(data.slice(0)[0]?.date || null)
    let lastDay = new Date(data.slice(-1)[0]?.date || null)

    firstDay.setDate(firstDay.getDate() - 1)
    lastDay.setDate(lastDay.getDate() + 1)
    // console.log(firstDay, lastDay)

    const timeFormatter = (tick: number) => timeFormat('%d-%m')(new Date(tick))
    const domainWeek = scaleTime().domain([timeDay.floor(firstDay), timeDay.floor(lastDay)]) //timeDay.offset(lastDay, -20)
    const ticks = domainWeek.ticks(timeDay.every(2)!)
    // console.log(ticks)
    // console.log(domainWeek.domain())


    const CustomTooltip = ({ active, payload, label, ...props }: TooltipProps) => {
        const translate = useTranslate()
        const classes = useStyles()

        if (active && payload && payload.length) {
            // console.log(payload)
            const [transfer, repayment, gross_sales] = payload

            const repaymentValue = (repayment?.value as number) / 100 || 0
            const transferValue = (transfer?.value as number) / 100 || 0

            const gross_salesValue = (gross_sales?.value as number) / 100 || 0

            return (
                <Card>
                    <CardContent className={classes.tooltip}>
                        <Typography variant="button" className={classes.tooltipLabel}>
                            {translate('resources.Merchant.dashboard.date') + ": " + timeFormat('%d-%m')(new Date(label as number))}
                        </Typography><br />
                        <Typography variant="caption" className={classes.tooltipLabel}>
                            {translate('resources.Merchant.dashboard.gross_sale') + ": "} <strong>{formatMoney(gross_salesValue as number, 1)}</strong>
                        </Typography><br />
                        <Typography variant="caption" className={classes.tooltipLabel} style={{ color: transfer?.fill }}>
                            {translate('resources.Merchant.dashboard.transfer_to_merchant') + ": "}<strong>{formatMoney(transferValue, 1)}</strong>
                        </Typography><br />
                        <Typography variant="caption" className={classes.tooltipLabel} style={{ color: repayment?.fill }}>
                            {translate('resources.Merchant.dashboard.repayment') + ": "} <strong>{formatMoney(repaymentValue, 1)}</strong>
                        </Typography>
                    </CardContent>
                </Card>
            );
        }

        return null;
    };

    return (
        <ResponsiveContainer width="90%" height="100%">
            <BarChart
                // width={400}
                // height={200}
                barSize={40}
                data={data as any}
                margin={{
                    // top: 20,
                    // right: 40,
                    right: 0,
                    left: 0,
                    // left: 40,
                    // bottom: 5,
                }}
            >
                <XAxis
                    dataKey='date'
                    domain={domainWeek.domain().map(d => d.getTime()) as any}
                    // domain={['dataMin', 'dataMax']}
                    scale='time'
                    type='number'
                    ticks={ticks}
                    tickFormatter={timeFormatter}
                />
                {/* <YAxis /> */}
                <Tooltip content={<CustomTooltip />} />
                <Legend verticalAlign="bottom" formatter={value => {
                    return translate(`resources.Merchant.dashboard.${value as string}`)
                }} />
                {/* <Bar dataKey="gross_sale" stackId="a" fill={theme.palette.primary.dark} /> */}
                <Bar dataKey="transfer" stackId="a" fill={theme.palette.primary.dark} >
                    {/* <LabelList dataKey="gross_sale" position="top" formatter={value => formatMoney(value as number, 1)} /> */}
                </Bar>
                <Bar dataKey="repayment" stackId="a" fill={theme.palette.primary.light} >
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
}

export default StackedBarchart;